module.exports = __webpack_public_path__ + "img/logo_stefanini_blanco.6291fc84.png";